import { render, staticRenderFns } from "./UserAgreementEdit.vue?vue&type=template&id=28f73e28&scoped=true&"
import script from "./UserAgreementEdit.vue?vue&type=script&lang=ts&"
export * from "./UserAgreementEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f73e28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
